import { Outlet } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

export default function Patients() {
  const [hospitalId] = useOutletContext();

  return <Outlet context={[hospitalId]} />;
}
